import { useMutation, useQueryClient } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

import { FETCH_ALL_UPLOADED_BIDS_KEY } from './useSearchUploadedBidsQuery';

/**
 * This is to track the update bid status mutation keys in react query cache.
 */
const MUT_UPLOAD_BID_BOOK_TEMPLATE = 'upload-bid-book-template-mutation-key';

interface IUseUploadBidBookTemplateMutation {
  onError?: () => void;
  onSuccess?: () => void;
}

/**
 * This performs a post request for uploading the bid book.
 * `useUploadBidBookMutation` is used to upload the bid book template in excel
 * format, but is an older implementation.
 */
export const useUploadBidBookTemplateMutation = ({
  onError,
  onSuccess,
}: IUseUploadBidBookTemplateMutation) => {
  const queryClient = useQueryClient();
  const {
    error,
    isError,
    isPending,
    mutate: uploadBidBook,
    reset,
  } = useMutation({
    mutationKey: [MUT_UPLOAD_BID_BOOK_TEMPLATE],
    networkMode: 'always', // Even make calls when offline
    mutationFn: BIDS_API.uploadBidBookTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FETCH_ALL_UPLOADED_BIDS_KEY],
      });

      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });

  return {
    uploadBidBook,
    error,
    isError,
    isUploading: isPending,
    reset,
  };
};
